import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { TodayTimeOrDatePipe } from '@zero/shared/ui-pipes';
import { IconButtonComponent } from '@zero/shared/ui-web-design-system';
import { TradeTickerBase } from '@zero/statistics/feature-statistics/base';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'statistics-trade-ticker',
  templateUrl: './trade-ticker.component.html',
  styleUrls: ['../../styles/statistics.scss', './trade-ticker.component.scss'],
  imports: [TranslocoPipe, RouterLink, TodayTimeOrDatePipe, IconButtonComponent, DecimalPipe, CurrencyPipe],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', [style({ opacity: 0 }), stagger('60ms', animate('600ms ease-out', style({ opacity: 1 })))], { optional: true }),
      ]),
    ]),
  ],
})
export class TradeTickerComponent extends TradeTickerBase {
  public readonly instrumentDetailsUrl = commonRoutes.postlogin.instrument_detail;
  public readonly collapsed = signal<boolean>(false);
  public collapse = () => this.collapsed.update((collapsed) => !collapsed);
}
